var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shown),expression:"shown"}],staticClass:"budget-mobile-open",on:{"click":_vm.showBudget}},[_c('img',{attrs:{"src":"/img/iconos/icon_budget.svg","alt":"icon_budget.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }